// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HomeBaseBanner":"te_a bib_b bib_bj","HomeBaseBanner__hint":"te_b bib_vh","HomeBaseBanner__link":"te_c"};